<div id="saving">
  <div>Ukládám...</div>
  <ion-spinner id="topSpinner" name="dots" color="tertiary"></ion-spinner>
</div>

<ionic-selectable
  #assistantSelectComponent
  itemTextField="firstName"
  [(ngModel)]="itemsSelected"
  [items]="itemsCurrentlyRendered"
  [disabledItems]="itemsCurrentlyRenderedDisabled"
  modalCssClass="assistant-select-modal"
  [canSearch]="true"
  [isEnabled]="isEnabled"
  [isMultiple]="true"
  [shouldFocusSearchbar]="!isTouchscreen"
  [hasVirtualScroll]="true"
  [shouldBackdropClose]="false"
  (onOpen)="onOpen()"
  (onSearch)="onSearch($event)"
  (onClose)="onIonicSelectableClose($event)"
  (onSelect)="onClickSelect($event)"
>
  <ng-template ionicSelectableSearchFailTemplate>
    <ion-row class="searchFailTemplateRow">
      <ion-spinner *ngIf="availabilitiesLoading"></ion-spinner>
      <span *ngIf="!availabilitiesLoading">Nic jsme nenašli.</span>
    </ion-row>
  </ng-template>

  <ng-template ionicSelectableValueTemplate let-availabilityItems="value"></ng-template>

  <ng-template ionicSelectableIconTemplate></ng-template>

  <ng-template ionicSelectableFooterTemplate>
    <ion-row class="footerStatusBar">
      <ion-col>
        <div *ngIf="assistantSelectComponent._selectedItems">
          Vybráno: {{ assistantSelectComponent._selectedItems.length }}
        </div>
      </ion-col>
    </ion-row>
    <ion-toolbar>
      <ion-row>
        <ion-col>
          <ion-button data-cy="confirmBtn" color="secondary" expand="block" (click)="confirm()">
            <ng-container *ngIf="confirming; else ok">
              <ion-spinner name="dots" color="dark"></ion-spinner>
            </ng-container>

            <ng-template #ok>OK</ng-template>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-toolbar>
  </ng-template>

  <ng-template ionicSelectableCloseButtonTemplate>
    <ion-icon name="close" style="font-size: 24px"></ion-icon>
  </ng-template>

  <ng-template ionicSelectableHeaderTemplate>
    <ion-toolbar>
      <ion-buttons slot="primary">
        <ion-button (click)="onAssistantModalCloseByCrossButton()">
          <ion-icon slot="icon-only" name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>
        <div>Dostupní asistenti</div>
        <span class="subtitle">
          {{ assistance?.client?.user?.lastName }}
          {{ assistance?.client?.user?.firstName }}
          {{ (getAssistanceRange()?.from | date: 'dd.MM. HH:mm') || 'Načítání' }} -
          {{ (getAssistanceRange()?.to | date: 'HH:mm') || 'Načítání' }}
        </span>
      </ion-title>
    </ion-toolbar>

    <ion-grid id="assistanceInfo" *ngIf="assistance?.coordinatorNote">
      <ion-row>
        <span class="label">Poznámka koordinace</span>
        <span>{{ assistance.coordinatorNote }}</span>
      </ion-row>
    </ion-grid>

    <ion-grid id="filter-row" *ngIf="recommendedAssistantsFilter && recommendedAssistantsFilter.values">
      <ion-row>
        <ion-col size="4">
          <ion-item>
            <app-gender-select
              label="Pohlaví"
              [(ngModel)]="recommendedAssistantsFilter.values.preferredGenderId"
              (ngModelChange)="onRecommendedAssistantsFilterChange()"
            ></app-gender-select>
          </ion-item>
        </ion-col>
        <ion-col size="4">
          <ion-item>
            <ion-checkbox
              [(ngModel)]="recommendedAssistantsFilter.values.needsStrongAssistant"
              (ionChange)="onRecommendedAssistantsFilterChange()"
              labelPlacement="start"
            >
              Silák/silačka
            </ion-checkbox>
          </ion-item>
        </ion-col>
        <ion-col size="4">
          <ion-item>
            <ion-checkbox
              [(ngModel)]="recommendedAssistantsFilter.values.needsAdvancedAssistant"
              (ionChange)="onRecommendedAssistantsFilterChange()"
              labelPlacement="start"
            >
              Pokročilý/á
            </ion-checkbox>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row id="btn-row">
        <ion-button (click)="switchSelectMode('availabilities')" *ngIf="(selectMode$ | async) === 'allAssistants'">
          <span class="desktop">zobrazit dostupné časy</span>
          <span class="mobile"><ion-icon name="time-outline"></ion-icon></span>
        </ion-button>
        <ion-button
          (click)="switchSelectMode('allAssistants')"
          *ngIf="(selectMode$ | async) === 'availabilities'"
          data-cy="allAssistantsBtn"
        >
          <span class="desktop">zobrazit všechny asistenty</span>
          <span class="mobile"><ion-icon name="people-outline"></ion-icon></span>
        </ion-button>

        <ion-button (click)="resetFilterToAssistanceDefaults()">
          <span class="desktop">zpět na hodnoty asistence</span>
          <span class="mobile">
            <fa-stack>
              <fa-icon [icon]="faFilter" stackItemSize="1x"></fa-icon>
              <fa-icon [icon]="faSlash" [inverse]="true" stackItemSize="1x"></fa-icon>
            </fa-stack>
          </span>
        </ion-button>

        <ion-button color="danger" (click)="clearAssistant()">
          <span class="desktop">odebrat asistenty</span>
          <span class="mobile"><ion-icon name="person-remove-outline"></ion-icon></span>
        </ion-button>
      </ion-row>
    </ion-grid>
  </ng-template>

  <ng-template ionicSelectableItemTemplate let-availItem="item" let-isAvailabilitySelected="isItemSelected">
    <div class="ionicSelectableItemTemplateWrapper">
      <ion-row class="ionicSelectableItemTemplateRow">
        <ion-col size="24" size-md="4">
          {{ availItem?.availability?.assistant?.worker?.user?.lastName }}
          {{ availItem?.availability?.assistant?.worker?.user?.firstName }}
        </ion-col>
        <ion-col size="24" size-md="2" class="desktop">
          <div
            *ngIf="availItem?.availability?.note"
            class="availabilityNote-cover text-center"
            (mouseenter)="showAvailabilityNoteFloatover(availItem, $event)"
            (mouseleave)="hideAvailabilityNoteFloatover()"
          >
            <ion-icon name="information-circle-outline"></ion-icon>
          </div>
        </ion-col>

        <ion-col size="24" size-md="7">
          {{ availItem?.availability?.assistant?.coordinatorNote }}
        </ion-col>

        <ion-col size="24" size-md="3" class="flags">
          <ion-chip *ngIf="availItem?.flags?.includes(AssistantAvailabilitySelectItemFlag.IsExchangeAssistance)">
            <ion-icon name="swap-vertical"></ion-icon>
            burza
          </ion-chip>
        </ion-col>

        <ion-col size="24" size-md="8" class="ionicSelectableItemEndTemplateWrapper">
          <div class="assistanceBefore">
            <ion-badge
              *ngIf="availItem.assistanceBeforeHHMM"
              [color]="availItem.assistanceBeforeHHMM >= -15 ? 'danger' : 'secondary'"
              (mouseenter)="showAssistanceBeforeInfo(availItem, $event)"
              (mouseleave)="hideAssistanceAroundInfo()"
            >
              {{ availItem.assistanceBeforeHHMM }} min
            </ion-badge>
          </div>

          <span class="itemDateTime">
            <span>
              <div class="itemDate">
                {{ availItem?.availability?.dt_start | date: 'dd.MM.' }}
              </div>
              <div>{{ availItem?.availability?.dt_start | date: 'HH:mm' }}</div>
            </span>
            <div
              style="line-height: 2"
              *ngIf="
                availItem?.availability?.dt_start || availItem.assistanceBeforeHHMM || availItem.assistanceAfterHHMM
              "
            >
              -
            </div>
            <span>
              <div
                class="itemDate"
                [ngClass]="{
                  overMidnight:
                    availItem?.availability?.getDateFrom()?.getDate() !==
                    availItem?.availability?.getDateTo()?.getDate(),
                }"
              >
                {{ availItem?.availability?.dt_end | date: 'dd.MM.' }}
              </div>
              <div>{{ availItem?.availability?.dt_end | date: 'HH:mm' }}</div>
            </span>
          </span>

          <div class="assistanceAfter">
            <ion-badge
              *ngIf="availItem.assistanceAfterHHMM"
              [color]="availItem.assistanceAfterHHMM <= 15 ? 'danger' : 'secondary'"
              (mouseenter)="showAssistanceAfterInfo(availItem, $event)"
              (mouseleave)="hideAssistanceAroundInfo()"
            >
              +{{ availItem.assistanceAfterHHMM }} min
            </ion-badge>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </ng-template>
</ionic-selectable>
